<!--
@Description: 时间选择器v2 ，选择项面向接口全部内容
@Author: 吳廣帥
@Date:2021/8/9 - 11:26
@Name:DateSwitchV2
@Version:v1.0
-->
<style lang="less">
.brand-date-picker {
  .van-dropdown-menu__bar{
    box-shadow: none!important;
    background: none!important;
    height: 40px;
  }
  .van-dropdown-menu {
    height: 0.0rem;

    .van-dropdown-item {
      z-index: 1;

      line-height: .8rem;
    }
  }
}
</style>
<style lang="less" scoped>
.brand-date-picker {
  width: 7.5rem;
  height: 0.8rem;
  background: #fff;
  padding-right: 0.3rem;

  .mode-select {
    height: 0.8rem;
    padding-left: .3rem;

    .mode-item {
      text-align: center;
      color: #4a4a4a;
      font-size: 0.28rem;
      line-height: 0.8rem;
    }

    .mode-item + .mode-item {
      margin-left: .2rem;
    }

    .mode-active {
      color: #2a89f4;
    }
  }

  .date-select {
    margin-left: auto;
  }

  .share-btn {
    margin-left: 0.25rem;
    height: 0.5rem;
    background: #ffffff;
    color: #2a89f4;
    border: 1px solid #2a89f4;
    font-size: 0.28rem;
    border-radius: 0.08rem;

    .icon {
      width: 0.28rem;
      height: 0.28rem;
      vertical-align: top;
    }
  }

  .search-icon {
    font-size: 0.4rem;
    line-height: 0.8rem;
    color: #4a4a4a;
    margin-left: 0.5rem;
  }
}
</style>

<style lang="less">
.brand-date-picker {
  .van-dropdown-menu {
    height: 0.8rem;

    &:after {
      display: none;
    }

    .van-dropdown-item {
      z-index: 1;
    }
  }
}
</style>
<template>
  <div class="align brand-date-picker ">
    <div class="mode-select align">
      <div v-for="(item, index) in chooseOptions"
           :key="index"
           @click="ClickDate(item, index)"
           class="mode-item"
           :class=" item.timeMode === FLAG.checked ? 'mode-active' : ''"
      >
        {{ item.label }}
      </div>
    </div>
    <div v-if="showSelect" class="mode-select date-select">
      <van-dropdown-menu>
        <van-dropdown-item @change="returnTime" v-model="DYNAMIC.v_model_value" :options="selectOptions" />
      </van-dropdown-menu>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import dayjs from "dayjs";

export default {

  /** 方法区 **/
  methods: {

    //todo -------------------- 交互 ----------------
    ClickDate(item,index){
      if(!this.FLAG.first && this.$props.disabled){
        return this.$emit('disabled')
      }
      this.FLAG.first = false
      this.FLAG.checked = item.timeMode
      this.DYNAMIC.v_model_value =
          this.FLAG.checked.includes('near') ?
          dayjs().subtract(1,"days").format('YYYYMMDD') :
          this.selectOptions[0].value
      this.returnTime()
    },
    //todo -------------------逻辑数据处理----------------
    /** timeMode 模式转 time区间格式 **/
    timeMode2time(){
      let duration = null
      switch (this.STATIC.timeMode[this.FLAG.checked].value) {
        case 1 :{
          duration = [
            moment().subtract(1,'days').startOf('days').unix(),
            moment().subtract(1,'days').endOf('days').unix()]
          break
        }
        case 7 :{
          duration = [
            moment().subtract(7,'days').startOf('days').unix(),
            moment().subtract(1,'days').endOf('days').unix()]
          break
        }
        case 30: {
          duration = [
            moment().subtract(30,'days').startOf('days').unix(),
            moment().subtract(1,'days').endOf('days').unix()]
          break
        }
        case 12: {
          duration = [
            moment(this.DYNAMIC.v_model_value).subtract(1,'months').startOf('days').unix(),
            moment(this.DYNAMIC.v_model_value).subtract(1,'days').endOf('days').unix()]
          break
        }
        case 13 :{
          duration = [
            moment(this.DYNAMIC.v_model_value).subtract(1,'weeks').startOf('days').unix(),
            moment(this.DYNAMIC.v_model_value).subtract(1,'days').endOf('days').unix()]
          break
        }
        case 14: {
          duration = [
            moment(this.DYNAMIC.v_model_value).subtract(1,'days').startOf('days').unix(),
            moment(this.DYNAMIC.v_model_value).subtract(1,'days').endOf('days').unix()]
          break
        }
      }
      return `{"$between":[${duration}]}`
    },
    //todo -------------------组件通信暴露-------------
    /** 返回时间 **/
    returnTime(){
      let obj = null
      if(this.$props.isTimeMode){
          obj = { time:this.DYNAMIC.v_model_value,  timeMode:this.STATIC.timeMode[this.FLAG.checked].value }
      }else{
        obj = this.timeMode2time()
      }
      this.$emit('switchTime',obj)
    }
  },
  mounted() {
    this.ClickDate(this.chooseOptions[1],0)
    this.returnTime()
  },

  /** 数据区 **/
  watch: {},
  props: {
    disabled:{ type:Boolean,default:false },
    isTimeMode:{ type:Boolean, default: true },
    chooseOptions:{
      type:Array,
      default: () => ([
        // {
        //   label: '单日',
        //   timeMode: 'nearDay',
        // },
        {
          label: '单日',
          timeMode: 'day'
        },
        {
          label: '7天',
          timeMode: 'nearWeek'
        },
        {
          label: '30天',
          timeMode: 'nearMonth'
        },
        {
          label: '自然周',
          timeMode: 'week'
        },
        {
          label: '自然月',
          timeMode: 'month'
        }
      ])
    }
  },
  computed: {
    /** 下拉框待选项 **/
    selectOptions(){
      let arr = [...new Array(this.STATIC.timeMode[this.FLAG.checked].length)] //生成数组长度
      switch (this.FLAG.checked){
        case 'nearDay' : {
          arr =  arr.map( (ele,index) => {
            return {
              text:moment().subtract(index + 1,'days').format('MM-DD'),
              value:moment().subtract(index + 1,'days').format('yyyyMMDD'),
            }
          })
          break
        }
        case 'day' : {
          arr =  arr.map( (ele,index) => {
            return {
              text:moment().subtract(index + 1,'days').format('MM-DD'),
              value:moment().subtract(index + 1,'days').format('yyyyMMDD'),
            }
          })
          break
        }
        case 'week' : {
          arr = arr.map( (ele,index) => {
            return {
              text:`${moment().subtract(index + 1, 'isoWeeks').startOf("isoWeeks").format('MM/DD')} - ${moment().subtract(index + 1, 'isoWeeks').endOf('isoWeeks').format('MM/DD')}`,
              value:moment().subtract(index + 1,'isoWeeks').endOf('isoWeeks').format('yyyyMMDD'),
            }
          })
          break
        }
        case 'month' : {
          arr = arr.map( (ele,index) => {
            return {
              text:`${moment().subtract(index + 1, 'months').startOf("months").format('MM/DD')} - ${moment().subtract(index + 1, 'months').endOf('months').format('MM/DD')}`,
              value:moment().subtract(index + 1,'months').endOf('months').format('yyyyMMDD'),
            }
          })
          break
        }
      }
      return arr
    },
    showSelect:(_this = this) => !!_this.STATIC.timeMode?.[_this.FLAG.checked]?.show
  },
  data() {
    return {
      /** 静态数据（存放静态地址、组件内静态json数据等） **/
      STATIC: {
        timeMode:{
          day:{
            show: true,
            value:14, // 返回参数格式
            length:7 // 控制显示长度
          },
          nearDay:{ // 近一天
            show: true,
            value: 1,
            length: 7
          },
          nearWeek:{
            value:7,
            length:0
          },
          nearMonth:{
            value:30,
            length:0
          },
          near6month:{
            value:60,
            length:0
          },
          near12month:{
            value:90,
            length:0
          },
          week:{
            show: true,
            value:13,
            length:5
          },
          month:{
            show: true,
            value:12,
            length:3
          },
        }
      },
      /** 控制状态 （存放判断标识、方法通信传递过程标识状态）**/
      FLAG: {
        first:true,
        checked:'day'
      },
      /** 上传数据 （存放请求api使用的params模板对象,一般使用form表单v-model绑定内容）**/
      PARAMS: {},
      /** 动态数据 （存放组件的动态改变信息）**/
      DYNAMIC: {
        v_model_value:''
      }
    }
  },
}
</script>








